import { Layout } from "../components/funnel";
import { Hero } from "../components/optin/Hero";
import { Learn } from "../components/optin/Learn";
import { WhoFor } from "../components/optin/WhoFor";
import { Mentor } from "../components/optin/Mentor";
import { Circle } from "../components/optin/Circle";
import { Receipts } from "../components/optin/Receipts";
import { SoundFamiliar } from "../components/optin/SoundFamiliar";
import { HearIt } from "../components/optin/HearIt";
import { FinalCTA } from "../components/optin/FinalCTA";

export default function OptInPage() {
  return (
    <Layout stickyCta>
      <Hero />
      <Learn />
      <WhoFor />
      <Mentor />
      <Circle />
      <Receipts />
      <SoundFamiliar />
      <HearIt />
      <FinalCTA />
    </Layout>
  );
}
